import logo from "./logo.svg";
import "./App.css";
import Gallery from "./Gallary";

function App() {
  return (
    <>
      <Gallery />
    </>
  );
}

export default App;
